export const OFFER_PARTNER_CONSENT_DOWNLOADED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferClientConsentFileDownloaded";
export const OFFER_CONSENT_DOCUMENT_UPLOADED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Documents.OfferConsentDocumentUploaded";
export const OFFER_CLIENT_CONSENT_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferClientConsentUpdated";
export const OFFER_PARTNER_CONSENTS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerConsentsUpdated";
export const OFFER_PARTNER_CONSENTS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerConsentsInvalidated";
export const OFFER_ASSOCIATED_PARTNER_CONSENT_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferAssociatedPartnerConsentUpdated";
export const OFFER_ASSOCIATED_PARTNER_CONSENTS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferAssociatedPartnerConsentsInvalidated";
